module.exports = __webpack_public_path__ + "img/horizontal-bar.97d3b454.svg";